<div class="justify-center items-center display-none" [id]="serverErrorId">
  <div>
    <i class="mdi mdi-alert-circle-outline alert-icon"></i>
  </div>
  <div>! There is a problem connecting with the server</div>
  <div>
    {{ "messages.noConnectionToServer" | translate }}
  </div>

    <btn
            size="icon"
            variant="solid"
            color="neutral"
            icon="mdi-refresh mdi-22px"
            customClass="mx-1"
            [tooltip]="'common.refresh' | translate"
            (clicked)="reload()"
          />
</div>
